import EntryBlock from "./EntryBlock/EntryBlock";
import ExampleBlock from "./ExampleBlock/ExampleBlock";
import HorizontalScroll from "./HorizontalScroll/HorizontalScroll";
import UseCases from "./UseCases/UseCases";
import FaqComponent from "../../FaqComponent/FaqComponent";

function EditorLanding({ dictionary, uploadFile }) {
	return (
		<div>
			<EntryBlock dictionary={dictionary} uploadFile={uploadFile} />
			<UseCases dictionary={dictionary} />
			<ExampleBlock dictionary={dictionary} />
			<HorizontalScroll dictionary={dictionary} />
			<FaqComponent dictionary={dictionary} pageName={"page_editor"} isPurpleBack={true} />
		</div>
	);
}

export default EditorLanding;
